import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { getFullApiUrl } from "../config";
import { Badge, BenefitItem, Button } from "../designSystem";

export default function MembershipIntroPage() {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const token = useSelector((state) => state.auth.token);
  const [isMember, setIsMember] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkMembershipStatus = async () => {
      if (!isAuthenticated || !token) {
        setLoading(false);
        setIsMember(false);
        return;
      }

      try {
        const response = await axios.get(
          getFullApiUrl("/api/v1/subscribe/user_payment_status"),
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // Check if user has paid
        setIsMember(response.data?.has_paid || false);
      } catch (error) {
        console.error("Failed to check membership status:", error);
        // For authentication errors or other issues, assume not a member
        setIsMember(false);
      } finally {
        setLoading(false);
      }
    };

    checkMembershipStatus();
  }, [isAuthenticated, token]);

  const currentYear = new Date().getFullYear();

  const benefits = [
    {
      icon: "lock_open",
      title: "收听付费节目",
      desc: "免费收听每月新发布的“付费节目”，并可以回听过往所有的“付费节目”。",
    },
    {
      icon: "forum",
      title: "年度会员微信群",
      desc: "免费加入年度会员微信群，随时和主播交流。",
    },
    {
      icon: "mic",
      title: "线上讲座与分享",
      desc: "参加各位主播定期的线上讲座与分享活动。相关内容不会作为常规节目发布，为年度会员独享。",
    },
    {
      icon: "chat",
      title: "专属咨询服务",
      desc: "可在会员网站、会员 APP（即将上线）和知识星球向各位主播、嘉宾发问或是共同探讨，享受个性化的专属咨询服务。",
    },
    {
      icon: "confirmation_number",
      title: "线下活动优惠",
      desc: `可参加${currentYear}年《边角聊》线下活动赠票抽选或享受 5 折优惠。`,
    },
  ];

  const handleJoin = () => {
    if (!isAuthenticated) {
      // If not logged in, redirect to login page
      navigate("/login");
    } else {
      // If logged in but unpaid, go to subscription plans page
      navigate("/subscription/plans");
    }
  };

  return (
    <div className="lt-main">
      <div className="lt-mem-hero">
        <span className="kicker">MEMBERSHIP</span>
        <h1>欢迎加入边角聊</h1>
        <p>升级为年度会员，解锁专属福利。</p>
      </div>

      <p className="lt-benefits-lead">
        凡加入《边角聊》年度会员的听友将能享受以下“福利”：
      </p>
      <div className="lt-benefits lt-benefits--3 lt-benefits--cards">
        {benefits.map((b) => (
          <BenefitItem key={b.title} icon={b.icon} title={b.title} desc={b.desc} />
        ))}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 14,
          paddingBottom: 24,
        }}
      >
        {isMember ? (
          <>
            <Badge variant="member" icon="verified">
              你已经是会员
            </Badge>
            <Button size="lg" variant="secondary" onClick={() => navigate("/")}>
              回去听节目
            </Button>
          </>
        ) : (
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", justifyContent: "center" }}>
            <Button size="lg" icon="workspace_premium" onClick={handleJoin} disabled={loading}>
              成为会员
            </Button>
            <Button size="lg" variant="ghost" onClick={() => navigate("/")}>
              下次再说
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
